<div class="pag-container">

  <app-campaign-3-breadcrumb
    #breadcrumbComponent
    [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)"
    homeLink="">
  </app-campaign-3-breadcrumb>

  <!-- Header -->
  <div class="ui-g-12 vertical-margin-20">
    <div class="ui-g-6 no-lateral-padding">
      <h1 class="title">
        {{ 'baskets.basket_creation' | translate }}
      </h1>
    </div>

    <div class="ui-g-6 d-flex justify-content-end">

      <button
        type="button"
        data-testid="back_button"
        class="btn-page-act"
        style="margin-right: 10px;"
        (click)="onBackAction()">

        <i class="pi pi-arrow-left margin-fit"></i>
        <span>{{ 'common.back' | translate }}</span>
      </button>

      <button
        type="button"
        data-testid="save_button"
        class="btn-page-act"
        (click)="onSaveChanges()">

        <i class="pi pi-save margin-fit"></i>
        <span>{{ 'common.save' | translate }}</span>
      </button>

    </div>
  </div>

  <!-- Section Title -->
  <div class="ui-g-12">
    <h2 class="title">
      {{ 'common.save' | translate }}
    </h2>
  </div>

  <!-- Form -->
  <div class="ui-g-12 vertical-margin-10 no-lateral-padding">

    <!-- Left Column -->
    <div class="ui-g-6">

      <div class="ui-g-12 no-lateral-padding">
        <app-form-fields
          #basket_name
          data-testid="basket_name"
          [(fieldModel)]="fieldModel.name"
          [type]="'string'"
          [label]="'baskets.list_name' | translate"
          [name]="'name'"
          [optionLabel]="'name'"
          [placeholder]="'baskets.list_name' | translate"
          [required]="true">
        </app-form-fields>
      </div>

      <div class="ui-g-12 no-lateral-padding">
        <app-form-fields
          #basket_code
          data-testid="basket_code"
          [(fieldModel)]="fieldModel.code"
          [type]="'string'"
          [label]="'baskets.code' | translate"
          [name]="'code'"
          [optionLabel]="'code'"
          [placeholder]="'baskets.code' | translate"
          [required]="true">
        </app-form-fields>
      </div>

    </div>

    <!-- Right Column -->
    <div class="ui-g-6" style="margin-top: 5px;">

      <app-form-fields
        #basket_description
        data-testid="basket_description"
        [(fieldModel)]="fieldModel.description"
        [type]="'textarea'"
        [label]="'baskets.list_description' | translate"
        [name]="'description'"
        [optionLabel]="'description'"
        [placeholder]="'baskets.enter_distribution_description' | translate"
        [required]="false">
      </app-form-fields>

    </div>

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-creation/basket-creation.component.html